import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { TableRow, TableCell, Slider, MenuItem, Grid } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { Select, TextField, Checkboxes } from 'mui-rff';
import { Field } from 'react-final-form';
import { LabResultAnalyte } from '../../../interfaces/lab-result';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    slider: {
      width: '20%',
      paddingTop: 45,
      paddingBottom: 10
    },
    failedValue: {
      textAlign: 'center',
    },
    textField: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 220,
    },
    comments: {
      width: '30%'
    },
    red: {
      color: red.A700,
    },
    abnormal: {
      color: red.A400,
    },
    critical: {
      color: red.A700,
    },
    highlight: {
      backgroundColor: theme.palette.action.hover,
    }
  }),
);

export default function LabResultComponent({name}: {name: string}) {
  const classes = useStyles();

  return (
    <Field name={name}>
      {(props) => {
        const component = props.input.value as LabResultAnalyte;
        const displayRangeLower = parseFloat(component.metadata.displayRangeLower);
        const displayRangeUpper = parseFloat(component.metadata.displayRangeUpper);
        const rangeFrom = parseFloat(component.range.from);
        const rangeTo = parseFloat(component.range.to);
        let minRange = displayRangeLower;
        let maxRange = displayRangeUpper;
        let color = 'primary';
        const value = (component.value || '').startsWith('>') ?
          parseFloat(component.value.slice(1, component.value.length)) :
          parseFloat(component.value);
        const marks = [
          { value: rangeFrom, label: component.range.from },
          { value: rangeTo, label: component.range.to }
        ];
        if (value < rangeFrom || value > rangeTo) {
          color = 'secondary';
        }
        if (value < minRange) {
          minRange = value;
        }
        if (value > maxRange) {
          maxRange = value;
        }
        // TODO: scale={(x) => x ** 10} when the value is super off.
        return (
          <React.Fragment>
            {component.metadata.category && component.metadata.category.orderNumberInCategory === 1 ? (
              <TableRow key={component.metadata.category.name}>
                <TableCell align="center" colSpan={10}>
                  <h4>{component.metadata.category.name}</h4>
                </TableCell>
              </TableRow>
            ) : null}
            <TableRow key={component.id} className={component.metadata.computedNormality !== 'Normal' ? classes.highlight : ''}>
              <TableCell align="center">
                <Checkboxes
                  name={`${name}.metadata.visible`}
                  data={{label: null, value: ''}}
                />
              </TableCell>
              <TableCell align="center">{component.code}</TableCell>
              <TableCell align="center">{component.name}</TableCell>
              <TableCell className={component.metadata.computedNormality !== 'Failed' ? classes.slider : classes.failedValue}>
                {
                  component.metadata.computedNormality !== 'Failed' ?
                    (
                      <Slider
                        name={`${name}.value`}
                        defaultValue={value}
                        color={color as any}
                        disabled
                        aria-labelledby="component"
                        getAriaValueText={(value) => value.toString()}
                        min={minRange}
                        max={maxRange}
                        marks={marks}
                        valueLabelDisplay="on"
                        step={null}
                      />
                    ) : (
                      <Grid
                        container
                        direction="row"
                        justify="space-around"
                        alignItems="center"
                      >
                        <div>
                          <div>Normal Range</div>
                          <div>{component.range.from} - {component.range.to}</div>
                        </div>
                      </Grid>
                    )
                }
              </TableCell>
              <TableCell align="center">{component.value}</TableCell>
              <TableCell align="center">{component.unit}</TableCell>
              <TableCell align="center">{component.metadata.computedNormality}</TableCell>
              <TableCell align="center">
                <Field name={`${name}.metadata.physicianNormality`} className={classes.formControl}>
                  {(props) => (
                    <Select
                      name={props.input.name}
                      className={props.input.value !==  "Normal" ? classes.red : ""}
                    >
                      <MenuItem value={""}><br /></MenuItem>
                      <MenuItem value={"Normal"}>Normal</MenuItem>
                      <MenuItem className={classes.abnormal} value={"Abnormal"}>Abnormal</MenuItem>
                      <MenuItem className={classes.critical} value={"Critical"}>Critical</MenuItem>
                    </Select>
                  )}
                </Field>
              </TableCell>
              <TableCell align="center" className={classes.comments}>
                <TextField
                  name={`${name}.metadata.physicianComment`}
                  className={classes.textField}
                  multiline
                  rows={2}
                  rowsMax={Infinity}
                />
              </TableCell>     
              <TableCell align="center"><br /></TableCell>
          </TableRow>
          </React.Fragment>
        );
      }}
    </Field>
  );
}